import { runtimeConfig } from '@/config/runtime-config';

// [OSPEC:smoke-testing] Debug utility (isDebug) used by coverage smoke tests for conditional logging

/**
 * Check if debug mode is enabled.
 * Reads from runtime config to allow production debugging when needed.
 *
 * Usage:
 *   import { isDebug } from '@/lib/debug';
 *   if (isDebug()) console.log('debug message');
 */
export function isDebug(): boolean {
  return runtimeConfig.config?.debug ?? false;
}

export function isTrace(): boolean {
  return runtimeConfig.config?.trace ?? false;
}

/**
 * Check if auth debug mode is enabled.
 * Reads from runtime config to allow detailed auth debugging when needed.
 *
 * Usage:
 *   import { isDebugAuth } from '@/lib/debug';
 *   if (isDebugAuth()) console.log('[Auth] debug message');
 */
export function isDebugAuth(): boolean {
  return runtimeConfig.config?.debug_auth ?? runtimeConfig.config?.debug ?? false;
}

/**
 * Check if signup debug mode is enabled.
 * Reads from runtime config to allow detailed signup debugging when needed.
 * Returns true if debug_signup is set OR if general debug is enabled.
 *
 * Usage:
 *   import { isDebugSignup } from '@/lib/debug';
 *   if (isDebugSignup()) console.log('[Signup] debug message');
 */
export function isDebugSignup(): boolean {
  return runtimeConfig.config?.debug_signup ?? runtimeConfig.config?.debug ?? false;
}
